import { Button } from '@cocoonspace/ui/components/button'
import {
	Empty,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from '@cocoonspace/ui/components/empty'
import { useLingui } from '@lingui/react/macro'
import { Link2OffIcon, PlusIcon } from 'lucide-react'

import { CreateEventTypeAction } from './create-event-type-action'

export const NoEventTypes = () => {
	const { t } = useLingui()

	return (
		<Empty className='flex-none p-8'>
			<EmptyHeader>
				<EmptyMedia>
					<Link2OffIcon className='!size-16 stroke-1' />
				</EmptyMedia>
			</EmptyHeader>

			<EmptyContent>
				<EmptyTitle>
					{t`Vous n'avez pas encore créé de type de rendez-vous.`}
				</EmptyTitle>

				<EmptyDescription className='flex flex-col gap-2'>
					{t`Ajouter un type de rendez-vous pour le partager sur votre page publique.`}
				</EmptyDescription>

				<CreateEventTypeAction>
					<Button size='sm'>
						<PlusIcon />
						{t`Créer`}
					</Button>
				</CreateEventTypeAction>
			</EmptyContent>
		</Empty>
	)
}
